import React from 'react';
import { Outlet } from 'react-router-dom';
// import Copyright from '../components/Copyright';

function AuthLayout() {
  return (
    <div>
      <div>
        <Outlet />
      </div>
      <div>
        {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
      </div>
    </div>
  );
}

export default AuthLayout;
